import LifestyleCharts from './lifestyle-charts'

export default LifestyleCharts
